import React from 'react';

import { useEffect } from 'react';
import { useGroupState, useGroupActions } from './GroupContext';
import { useGroupCapabilities } from './useGroupCapabilities';
import { useCapabilities } from '../../Shared/capabilities';
import GroupLoader from './GroupLoader';
import GroupName from './GroupName';
import GroupProfilePicture from './GroupProfilePicture';
import GroupDescription from './GroupDescription';
import Sidebar from '../../Shared/UI/Sidebar/components/Sidebar';
import SidebarItem from '../../Shared/UI/Sidebar/components/SidebarItem';
import FEATURE_SIDEBAR_ITEMS from './featureSidebarItems';

import styles from './Group.module.scss';

const Group = ({ id }) => {
  const state = useGroupState();
  const { initializeState } = useGroupActions();

  useEffect(() => {
    initializeState(id);
  }, []);

  useGroupCapabilities();
  const capabilities = useCapabilities();

  const groupPath = state?.group?.path || `/groups/${id}`;

  return (
    <>
      <GroupLoader />
      <section id={styles.groupContainer}>
        <div id={styles.groupBody}>
          <Sidebar aria-label="Group navigation">
            <SidebarItem href={groupPath} active>Overview</SidebarItem>
            <SidebarItem href={`${groupPath}/members`}>Members</SidebarItem>
            {state?.group?.enabledFeatures?.map(feature => {
              const config = FEATURE_SIDEBAR_ITEMS[feature];
              if (!config) return null;
              if (config.capability && !capabilities[config.capability]) return null;
              return (
                <SidebarItem key={feature} href={`${groupPath}${config.path}`}>
                  {config.label}
                </SidebarItem>
              );
            })}
            {capabilities.canManageInvitations && (
              <SidebarItem href={`${groupPath}/invitations`}>Invitations</SidebarItem>
            )}
            {capabilities.canAccessSettings && (
              <SidebarItem href={`${groupPath}/settings`}>Settings</SidebarItem>
            )}
          </Sidebar>
          <div id={styles.groupContent}>
            <GroupName />
            <GroupProfilePicture />
            <GroupDescription />
          </div>
        </div>
      </section>
    </>
  );
};

export default Group;
